import { render, staticRenderFns } from "./IndividualInfoHeader.vue?vue&type=template&id=1b3c8176&scoped=true"
import script from "./IndividualInfoHeader.vue?vue&type=script&lang=js"
export * from "./IndividualInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./IndividualInfoHeader.vue?vue&type=style&index=0&id=1b3c8176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c8176",
  null
  
)

export default component.exports